import React, { useState, useEffect, useContext } from "react";
import { Settings2, Mail } from "lucide-react";
import { getConfigs, updateConfigs, getAppConfigs, updateAppConfigs } from "../api";
import { AuthContext } from "../AuthContext";

export default function SettingsAdjust() {
  const { user } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  const [settings, setSettings] = useState({
    smtp_auth: 1,
    host: "",
    username: "",
    password: "",
    smtp_secure: "ssl",
    port: 465,
    email: "",
    alias: ""
  });

  const [appConfig, setAppConfig] = useState({
    itensPorPagina: 0,
    language: "pt-BR",
    descontoMaximo: 0,
    pixKey: "",
    nomeFantasia: "",
    cidade: ""
  });

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const cfg = await getConfigs(user.token);
        if (cfg.length > 0) {
          setSettings({ 
            ...cfg[0], 
            password: "" // não exibir senha atual por segurança
          });
        }
        const appCfg = await getAppConfigs(user.token);
        if (appCfg) setAppConfig(appCfg);
      } catch (e) {
        console.error(e);
      } finally {
       setLoading(false);
      }
    }
    load();
  }, [user.token]);

  function handleChange(e) {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  }

  function handleAppChange(e) {
    const { name, value } = e.target;
    setAppConfig(prev => ({
      ...prev,
      [name]: name === "itensPorPagina" || name === "descontoMaximo"
        ? Number(value)
        : value
    }));
  }

  async function handleAppSubmit(e) {
    e.preventDefault();
    setSubmitting(true);

    try {
      await updateAppConfigs(user.token, appConfig);

      const payload = {
        ...settings,
        chave_pix: appConfig.chavePix,
        nome_fantasia: appConfig.nomeFantasia,
        cidade: appConfig.cidade
      };
      if (!payload.password) {
        delete payload.password; // não altera a senha se não foi digitada
      }

      await updateConfigs(user.token, payload);
      //alert("Configurações do sistema salvas");
    } catch (e) {
      alert("Erro ao salvar");
    }

    setSubmitting(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = { ...settings };
      if (!payload.password) {
        delete payload.password; // não altera a senha se não foi digitada
      }

      const result = await updateConfigs(user.token, payload);
      console.log("Configurações atualizadas:", result);
      alert("Configurações salvas com sucesso");
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar configurações");
    }

    setSubmitting(false);
  }

  return (
    <div className="page-container">
      <div className="dashboard-container">
        <div className="user-grid">
          <div className="user-card">
            <h3>
              <Settings2 size={20} /> Configurações Gerais
            </h3>
            <h4>
              <Mail size={20} /> Configurações do Email
            </h4>

            {loading ? (
              <div className="center-content">
                <div className="spinner"></div>
                <p>Carregando configurações do email...</p>
              </div>
            ) : (
                <form onSubmit={handleSubmit} className="card-actions">
                    <div className="form-group labels input-config">
                        <label>Host SMTP:</label>
                        <input type="text" name="host" value={settings.host} onChange={handleChange} />
                    </div>

                    <div className="form-group labels input-config">
                        <label>Usuário:</label>
                        <input type="text" name="username" value={settings.username} onChange={handleChange} />
                    </div>

                    <div className="form-group labels input-config">
                        <label>Senha:</label>
                        <input type="password" name="password" value={settings.password} onChange={handleChange} />
                        <small>Deixe em branco para manter a senha atual</small>
                    </div>

                    <div className="form-group labels input-config">
                        <label>Porta:</label>
                        <input type="number" name="port" value={settings.port} onChange={handleChange} />
                    </div>

                    <div className="form-group labels input-config">
                        <label>Segurança:</label>
                        <select name="smtp_secure" value={settings.smtp_secure} onChange={handleChange}>
                        <option value="ssl">SSL</option>
                        <option value="tls">TLS</option>
                        </select>
                    </div>

                    <div className="form-group labels input-config">
                        <label>Email do remetente:</label>
                        <input type="email" name="email" value={settings.email} onChange={handleChange} />
                    </div>

                    <div className="form-group labels input-config">
                        <label>Nome do remetente:</label>
                        <input type="text" name="alias" value={settings.alias} onChange={handleChange} />
                    </div>

                    <button type="submit" className="btn-primary" disabled={submitting}>
                        {submitting ? <div className="spinner"></div> : ""} Salvar Configurações
                    </button>
                </form>
            )}
          </div>

          <div className="user-card">
            <h3>
              <Settings2 size={20} /> Configurações do Sistema
            </h3>

            <form onSubmit={handleAppSubmit} className="card-actions">

              <div className="form-group labels input-config">
                <label>Itens por página:</label>
                <input
                  type="number"
                  name="itensPorPagina"
                  value={appConfig.itensPorPagina}
                  onChange={handleAppChange}
                />
              </div>

              <div className="form-group labels input-config">
                <label>Idioma:</label>
                <input
                  type="text"
                  name="language"
                  value={appConfig.language}
                  onChange={handleAppChange}
                />
              </div>

              <div className="form-group labels input-config">
                <label>Desconto máximo (%):</label>
                <input
                  type="number"
                  name="descontoMaximo"
                  value={appConfig.descontoMaximo}
                  onChange={handleAppChange}
                />
              </div>

              <div className="form-group labels input-config">
                <label>Chave PIX:</label>
                <input
                  type="text"
                  name="chavePix"
                  value={appConfig.chavePix || ""}
                  onChange={handleAppChange}
                />
              </div>

              <div className="form-group labels input-config">
                <label>Nome Fantasia:</label>
                <input
                  type="text"
                  name="nomeFantasia"
                  value={appConfig.nomeFantasia || ""}
                  onChange={handleAppChange}
                />
              </div>

              <div className="form-group labels input-config">
                <label>Cidade:</label>
                <input
                  type="text"
                  name="cidade"
                  value={appConfig.cidade || ""}
                  onChange={handleAppChange}
                />
              </div>

              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? <div className="spinner"></div> : ""} Salvar Configurações
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
